// Module
var code = "<amt-radio-button label=\"{{label}}\" name=\"{{name}}\" options=\"options\" on-change=\"onChange\" ng-model=\"filterItem.value\" ng-required=\"{{isRequired}}\"> </amt-radio-button>";
// Exports
module.exports = code;